import { registerQuery, registerMutation, useMutation, useQuery } from 'data-fetching-client';
import { useCallback } from 'react';
import { getLocalStore } from '../utils/superstore';
export const READ_LOCAL_STORE_FIELD_NAME = 'listingliblocalStoreRead';
export const READ_LOCAL_STORE = registerQuery({
  fieldName: READ_LOCAL_STORE_FIELD_NAME,
  args: ['key'],
  fetcher({
    key
  }) {
    return getLocalStore().get(key).then(value => {
      return {
        key,
        value
      };
    });
  }
});
export const WRITE_LOCAL_STORE_FIELD_NAME = 'listingliblocalStoreWrite';
export const WRITE_LOCAL_STORE = registerMutation({
  fieldName: WRITE_LOCAL_STORE_FIELD_NAME,
  args: ['key', 'value'],
  fetcher({
    key,
    value
  }) {
    return getLocalStore().set(key, value).then(result => {
      return {
        key,
        value: result
      };
    });
  }
});
export function useReadLocalStore(key, options) {
  var _queryResult$data;
  const queryResult = useQuery(READ_LOCAL_STORE, Object.assign({
    variables: {
      key,
      options
    }
  }, options));
  return Object.assign({}, queryResult, {
    data: (_queryResult$data = queryResult.data) === null || _queryResult$data === void 0 ? void 0 : _queryResult$data[READ_LOCAL_STORE_FIELD_NAME]
  });
}
export function useWriteLocalStore() {
  var _mutationResult$data;
  const [trigger, mutationResult] = useMutation(WRITE_LOCAL_STORE, {
    optimisticResponse(variables) {
      return {
        [WRITE_LOCAL_STORE_FIELD_NAME]: {
          key: variables.key,
          value: variables.value
        }
      };
    },
    update(cache, {
      data
    }) {
      if ((data === null || data === void 0 ? void 0 : data[WRITE_LOCAL_STORE_FIELD_NAME].value) === null) {
        return;
      }
      cache.writeQuery({
        query: READ_LOCAL_STORE,
        variables: {
          key: data === null || data === void 0 ? void 0 : data[WRITE_LOCAL_STORE_FIELD_NAME].key
        },
        data: {
          [READ_LOCAL_STORE_FIELD_NAME]: data === null || data === void 0 ? void 0 : data[WRITE_LOCAL_STORE_FIELD_NAME]
        }
      });
    }
  });
  const triggerMutation = useCallback(({
    key,
    value
  }) => {
    return trigger({
      variables: {
        key,
        value
      }
    });
  }, [trigger]);
  return [triggerMutation, Object.assign({}, mutationResult, {
    data: (_mutationResult$data = mutationResult.data) === null || _mutationResult$data === void 0 ? void 0 : _mutationResult$data[WRITE_LOCAL_STORE_FIELD_NAME]
  })];
}